export default __webpack_public_path__ + "static/media/Exterior (4).fec8dace.jpg";